import React from 'react';
import { useTranslation } from 'react-i18next';
import { Field } from 'react-final-form';

import CustomerSection from '../customer-section/CustomerSection';
import WithLabel, { LABEL_STYLES } from '../../../components/with-label/WithLabel';
import WithError from '../../../components/with-error/WithError';
import { Input } from '../../../components/common-inputs';

import scss from './CompanyForm.module.scss';

const CompanyForm = () => {
  const { t } = useTranslation('customers');

  return (
    <CustomerSection title={t('addCompany')}>
      <div className={scss.companyForm}>
        <Field name='companyName'>
          {({ input, meta }) => (
            <WithLabel label={t('name')} variant={LABEL_STYLES.CUSTOM} extraClassName={scss.formRow}>
              <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
                <Input size='sm' formProps={input} isError={meta.touched && meta.error} />
              </WithError>
            </WithLabel>
          )}
        </Field>

        <Field name='companyContact'>
          {({ input, meta }) => (
            <WithLabel label={t('contact')} variant={LABEL_STYLES.CUSTOM} extraClassName={scss.formRow}>
              <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
                <Input size='sm' formProps={input} isError={meta.touched && meta.error} />
              </WithError>
            </WithLabel>
          )}
        </Field>

        <Field name='companyAddress'>
          {({ input, meta }) => (
            <WithLabel label={t('address')} variant={LABEL_STYLES.CUSTOM} extraClassName={scss.formRow}>
              <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
                <Input size='sm' formProps={input} isError={meta.touched && meta.error} />
              </WithError>
            </WithLabel>
          )}
        </Field>

        <Field name='companyEmail'>
          {({ input, meta }) => (
            <WithLabel label={t('email')} variant={LABEL_STYLES.CUSTOM} extraClassName={scss.formRow}>
              <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
                <Input size='sm' formProps={input} isError={meta.touched && meta.error} />
              </WithError>
            </WithLabel>
          )}
        </Field>

        <Field name='companyCity'>
          {({ input, meta }) => (
            <WithLabel label={t('city')} variant={LABEL_STYLES.CUSTOM} extraClassName={scss.formRow}>
              <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
                <Input size='sm' formProps={input} isError={meta.touched && meta.error} />
              </WithError>
            </WithLabel>
          )}
        </Field>

        <Field name='companyZip'>
          {({ input, meta }) => (
            <WithLabel label={t('zip')} variant={LABEL_STYLES.CUSTOM} extraClassName={scss.formRow}>
              <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
                <Input size='sm' formProps={input} isError={meta.touched && meta.error} />
              </WithError>
            </WithLabel>
          )}
        </Field>
      </div>
    </CustomerSection>
  );
};

export default CompanyForm;
